import { Capacitor } from '@capacitor/core'

export const checkPersistentStorage = () => {
  // In native platforms, the storage is persistent by default
  if (Capacitor.isNativePlatform()) {
    return Promise.resolve(true)
  }

  // For PWA, we check if the storage is persistent
  if (navigator.storage && 'persist' in navigator.storage) {
    return navigator.storage.persisted()
  }
  return Promise.resolve(false)
}

export const requestPersistentStorage = async () => {
  // In native platforms, the storage is persistent by default
  if (Capacitor.isNativePlatform()) {
    return true
  }

  // For PWA, we request persistent storage
  try {
    if (navigator.storage && 'persist' in navigator.storage) {
      const isPersisted = await navigator.storage.persist()
      return isPersisted
    }
  } catch (e) {
    console.error('Error requesting persistent storage', e)
  }
  return false
}

export const requestPersistentStorageIfNeeded = async () => {
  // In native platforms, it is not necessary to request persistent storage
  if (Capacitor.isNativePlatform()) {
    return
  }

  // For PWA, we check and request if it is necessary
  const isPersisted = await checkPersistentStorage()
  if (!isPersisted) {
    await requestPersistentStorage()
  }
}
